/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import {
  ApiComponent,
  ApiComponentFromJSON,
  ApiComponentFromJSONTyped,
  ApiComponentToJSON,
} from './ApiComponent';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';

/**
 *
 * @export
 * @interface ApiNoContent
 */
export interface ApiNoContent extends ApiComponent {}

export function ApiNoContentFromJSON(json: any): ApiNoContent {
  return ApiNoContentFromJSONTyped(json, false);
}

export function ApiNoContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNoContent {
  return json;
}

export function ApiNoContentToJSON(value?: ApiNoContent | null): any {
  return value;
}
